import { render, staticRenderFns } from "./TheIndexHeader.vue?vue&type=template&id=f8c6cca0&scoped=true"
import script from "./TheIndexHeader.vue?vue&type=script&lang=js"
export * from "./TheIndexHeader.vue?vue&type=script&lang=js"
import style0 from "./TheIndexHeader.vue?vue&type=style&index=0&id=f8c6cca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c6cca0",
  null
  
)

export default component.exports